// extracted by mini-css-extract-plugin
export default {"toast":"WBAY8","ms-Icon":"_pS4s","actionButton":"cxTKU","icon":"upust","textAndIconContainer":"jKlsu","toastMultiButton":"g9Ggm","toastLabel":"SWAXD","buttonContainer":"Xiolt"};